module.exports = __webpack_public_path__ + "img/inactivity.43a46a62.svg";